const copywritings = window.config.copywritings;

export default function PortalFooter() {
    return (
        <footer className="flex justify-center w-full bg-brand-background">
            <div className="flex flex-col w-full justify-between relative gap-3 p-2 sm:p-6 !pt-0 text-brand-neutral-400 text-xs">
                <div className="">{copywritings.footer.legal}</div>
                <div className="">{copywritings.footer.compliance}</div>
                <div className="">
                    {copywritings.footer.marketing}{' '}
                    <span
                        className="underline cursor-pointer hover:text-brand-primary-light"
                        onClick={() => window.open('www.gc.exchange', '_blank')}>
                        www.gc.exchange
                    </span>
                </div>
                <div className="">
                    {copywritings.general.support}{' '}
                    <span
                        className="underline cursor-pointer hover:text-brand-primary-light"
                        onClick={() => window.open('mailto:clientservices@gc.exchange', '_blank')}>
                        clientservices@gc.exchange
                    </span>
                </div>
                <div className="">
                    {copywritings.general.terms}{' '}
                    <span
                        className="underline cursor-pointer hover:text-brand-primary-light"
                        onClick={() => window.open('https://knowledge.gc.exchange/knowledge', '_blank')}>
                        https://knowledge.gc.exchange/knowledge
                    </span>
                </div>
            </div>
        </footer>
    );
}
